// SignupForm.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock, FaUser, FaPhone, FaMapMarker, FaGoogle, FaFacebook } from 'react-icons/fa';
import axios from 'axios';
const SignupForm = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState('traveler');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    country: '',
    phone: '',
    termsAccepted: false,
    newsletterSubscribed: false
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
    
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.termsAccepted) {
      setError('You must accept the terms and conditions.');
      return;
    }
    if (!formData.email || !formData.password || !formData.firstName || !formData.lastName) {
      setError('All fields are required.');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setError('Please enter a valid email address.');
      return;
    }
    if (formData.password.length < 8) {
      setError('Password should be at least 8 characters.');
      return;
    }
    // Set loading state
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage('');

    try {
      // Send the signup request to your backend API
      const response = await axios.post('http://192.168.56.1:5001/api/users/register', {
        ...formData,
        userType
      });

      // Handle successful signup (e.g., redirect to a welcome page)
      console.log('Signup successful:', response.data);
      setSuccessMessage('Your account has been created successfully!');
      // Redirect or update UI accordingly
      navigate('/login'); 

    } catch (err) {
      // Handle error
      setError(err.response?.data?.message || 'Signup failed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <StyledSignupPage>
      <motion.div 
        className="form-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="form-header">
          <motion.h2 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Create Your Account
          </motion.h2>
          <div className="header-accent"></div>
          <div className="user-type-toggle">
            <button 
              className={userType === 'traveler' ? 'active' : ''}
              onClick={() => setUserType('traveler')}
            >
              As Traveler
            </button>
            <button 
              className={userType === 'guide' ? 'active' : ''}
              onClick={() => setUserType('guide')}
            >
              As Tour Guide
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <motion.div 
            className="input-group"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
          >
            <div className="icon"><FaEnvelope /></div>
            <input 
              type="email" 
              placeholder="Email address"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </motion.div>

          <motion.div 
            className="input-group"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
          >
            <div className="icon"><FaLock /></div>
            <input 
              type="password" 
              placeholder="Password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
            />
          </motion.div>

          <div className="input-row">
            <motion.div 
              className="input-group"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6 }}
            >
              <div className="icon"><FaUser /></div>
              <input 
                type="text" 
                placeholder="First Name"
                value={formData.firstName}
                onChange={(e) => setFormData({...formData, firstName: e.target.value})}
              />
            </motion.div>

            <motion.div 
              className="input-group"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6 }}
            >
              <div className="icon"><FaUser /></div>
              <input 
                type="text" 
                placeholder="Last Name"
                value={formData.lastName}
                onChange={(e) => setFormData({...formData, lastName: e.target.value})}
              />
            </motion.div>
          </div>

          <div className="input-row">
            <motion.div 
              className="input-group"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.7 }}
            >
              <div className="icon"><FaMapMarker /></div>
              <input 
                type="text" 
                placeholder="Country"
                value={formData.country}
                onChange={(e) => setFormData({...formData, country: e.target.value})}
              />
            </motion.div>

            <motion.div 
              className="input-group"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.7 }}
            >
              <div className="icon"><FaPhone /></div>
              <input 
                type="tel" 
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
              />
            </motion.div>
          </div>

          <motion.div 
            className="checkbox-group"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            <label>
              <input 
                type="checkbox"
                checked={formData.termsAccepted}
                onChange={(e) => setFormData({...formData, termsAccepted: e.target.checked})}
              />
              <span>I accept the Terms and Conditions & Privacy Policy</span>
            </label>
          </motion.div>

          <motion.div 
            className="checkbox-group"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9 }}
          >
            <label>
              <input 
                type="checkbox"
                checked={formData.newsletterSubscribed}
                onChange={(e) => setFormData({...formData, newsletterSubscribed: e.target.checked})}
              />
              <span>I want to receive updates and special offers</span>
            </label>
          </motion.div>

          <motion.button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Creating Account...' : 'Create Account'}
          </motion.button>
          {error && <p className="error-message">{error}</p>}
          {successMessage && <div className="success-message">{successMessage}</div>}
          <div className="divider">
            <span>or sign up with</span>
          </div>

          <div className="social-login">
            <motion.button
              type="button"
              className="google"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaGoogle /> Google
            </motion.button>
            <motion.button
              type="button"
              className="facebook"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaFacebook /> Facebook
            </motion.button>
          </div>

          <motion.div 
            className="login-prompt"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            Already have an account? <Link to="/login">Sign in</Link>
          </motion.div>
        </form>
      </motion.div>
      
      <div className="background-decoration"></div>
    </StyledSignupPage>
  );
};

const StyledSignupPage = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(135deg, #f6f9fc 0%, #f1f4f8 100%);
  position: relative;
  overflow: hidden;

  .background-decoration {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 10% 20%, rgba(45, 123, 168, 0.05) 0%, transparent 20%),
      radial-gradient(circle at 90% 80%, rgba(52, 73, 94, 0.05) 0%, transparent 20%);
    z-index: 0;
  }

  .form-container {
    width: 100%;
    max-width: 580px;
    background: white;
    padding: 40px;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 1;
  }

  .form-header {
    text-align: center;
    margin-bottom: 40px;

    h2 {
      font-size: 2rem;
      color: #1e293b;
      margin-bottom: 15px;
    }

    .header-accent {
      width: 60px;
      height: 4px;
      background: linear-gradient(45deg, #2d7ba8, #34495e);
      margin: 0 auto;
      border-radius: 2px;
    }
  }

  .user-type-toggle {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;

    button {
      padding: 10px 20px;
      border: 1px solid #e2e8f0;
      background: #f8fafc;
      color: #64748b;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #2d7ba8;
        color: white;
        border-color: #2d7ba8;
      }
    }
  }

  .input-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }

  .input-group {
    position: relative;
    margin-bottom: 20px;

    .icon {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      color: #94a3b8;
    }

    input {
      width: 100%;
      padding: 15px 15px 15px 45px;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      font-size: 1rem;
      transition: all 0.3s ease;

      &:focus {
        outline: none;
        border-color: #2d7ba8;
        box-shadow: 0 0 0 3px rgba(45, 123, 168, 0.1);
      }
    }
  }

  .checkbox-group {
    margin-bottom: 15px;

    label {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #64748b;
      cursor: pointer;

      input {
        accent-color: #2d7ba8;
      }
    }
  }

  button[type="submit"] {
    width: 100%;
    padding: 15px;
    background: linear-gradient(45deg, #2d7ba8, #34495e);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 20px 0;

    &:hover {
      transform: translateY(-1px);
    }
  }

  .divider {
    text-align: center;
    margin: 20px 0;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: calc(50% - 70px);
      height: 1px;
      background: #e2e8f0;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }

    span {
      background: white;
      padding: 0 20px;
      color: #64748b;
      font-size: 0.9rem;
    }
  }

  .social-login {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #f8fafc;
      color: #475569;
      border: 1px solid #e2e8f0;
      padding: 12px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &.google:hover {
        background: #f1f5f9;
      }

      &.facebook {
        background: #1877f2;
        color: white;
        border: none;
      }
    }
  }

  .login-prompt {
    text-align: center;
    color: #64748b;

    a {
      color: #2d7ba8;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 580px) {
    .form-container {
      padding: 30px 20px;
    }

    .input-row {
      grid-template-columns: 1fr;
      gap: 0;
    }

    .social-login {
      grid-template-columns: 1fr;
    }
  }
`;

export default SignupForm;